import { useRef } from 'react'

import classnames from 'classnames'

import Loading from 'common/components/loading'
import { ThankYouContainer } from 'modules/transmission/components/thankYou'
import { Status, Transmission } from 'modules/transmission/types'
import VideoContainer from 'modules/transmission/containers/video'
import ChatTabs from 'modules/chat/components/chatTabs/chatTabs'
import TabManager from 'modules/transmission/components/tabManager'
import ChatContainer from 'modules/chat/containers/chat'
import TransmissionHelper from 'common/helpers/transmission'
import useSetLeadAsWatched from 'modules/lead/hooks/useSetLeadAsWatched'
import { useLiveRequestWithRetry } from 'modules/transmission/hooks/useLiveRequestWithRetry'

export type LiveProps = {
  embedUrl: string,
  isMobile: boolean,
  isChatVisible?: boolean
}

const Live = ({ isMobile, embedUrl, isChatVisible }: LiveProps) => {
  const setLeadAsWatched = useSetLeadAsWatched()

  const statusRef = useRef<Status | undefined>()

  const onSuccess = (data: Transmission) => {
    if (
      statusRef.current
      && [Status.CREATED, Status.CREATING].includes(statusRef.current)
      && data.status === Status.STARTED
    ) {
      setLeadAsWatched(data.conversationId)
    }

    statusRef.current = data.status
  }
  const { data: transmission, isLoading: transmissionLoading } = useLiveRequestWithRetry()

  if (transmission) {
    onSuccess(transmission)
  }

  const renderMobileTabs = () => {
    return (
      <>
        <ChatTabs />
        <TabManager mediaCode={transmission?.mediaCode} />
      </>
    )
  }

  const renderChat = () => {
    return <ChatContainer mediaCode={transmission?.mediaCode} />
  }

  const renderRightColumn = () => {
    return isMobile ? renderMobileTabs() : renderChat()
  }

  const shouldDisplayThankYouPage = transmission?.status === Status.COMPLETED
  const theaterMode = !(isChatVisible || shouldDisplayThankYouPage)
  const classes = classnames('live-container', {
    'is-mobile': isMobile,
    'theater-mode': theaterMode
  })

  if (transmissionLoading || !transmission) {
    return (
      <div className="loading-container">
        <Loading />
      </div>
    )
  }

  const isHotmartProvider = TransmissionHelper.isHotmartProvider(
    transmission.provider
  )
  const endPlayer
    = transmission?.status === Status.COMPLETED
    && !transmission.enableVodPlayback

  return (
    <div className={classes} data-test="live-container">
      <VideoContainer
        transmission={transmission}
        isHotmartProvider={isHotmartProvider}
        embedUrl={embedUrl}
        theaterMode={theaterMode}
        endPlayer={endPlayer}/>
      <div
        className={classnames('second-column chat-container', {
          'chat-is-visible': isChatVisible
        })}>
        {shouldDisplayThankYouPage ? (
          <ThankYouContainer transmission={transmission} />
        ) : (
          renderRightColumn()
        )}
      </div>
    </div>
  )
}

export default Live
